import { Inject, Injectable, Injector } from '@angular/core';

import { Discussions_FlowService } from './Discussions.flow.index';
import { Utilities_FlowService } from './Utilities.flow.index';
import { Addresses_FlowService } from './Addresses.flow.index';
import { AsnOrders_FlowService } from './AsnOrders.flow.index';
import { Attachments_FlowService } from './Attachments.flow.index';
import { Carriers_FlowService } from './Carriers.flow.index';
import { Instructions_FlowService } from './Instructions.flow.index';
import { ExcelOrderImport_FlowService } from './ExcelOrderImport.flow.index';
import { Locations_FlowService } from './Locations.flow.index';
import { Lots_FlowService } from './Lots.flow.index';
import { LoadContainers_FlowService } from './LoadContainers.flow.index';
import { Owners_FlowService } from './Owners.flow.index';
import { PurchaseOrders_FlowService } from './PurchaseOrders.flow.index';
import { Invoices_FlowService } from './Invoices.flow.index';
import { Notifications_FlowService } from './Notifications.flow.index';
import { Materials_FlowService } from './Materials.flow.index';
import { DockAppointments_FlowService } from './DockAppointments.flow.index';
import { SerialNumbers_FlowService } from './SerialNumbers.flow.index';
import { SalesOrders_FlowService } from './SalesOrders.flow.index';
import { Inventory_FlowService } from './Inventory.flow.index';


import { $types } from './FootPrintPortalManager.types'

@Injectable({ providedIn: 'root' })
export class FootPrintPortalManager_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Discussions = this.injector.get(Discussions_FlowService);
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.Addresses = this.injector.get(Addresses_FlowService);
    this.AsnOrders = this.injector.get(AsnOrders_FlowService);
    this.Attachments = this.injector.get(Attachments_FlowService);
    this.Carriers = this.injector.get(Carriers_FlowService);
    this.Instructions = this.injector.get(Instructions_FlowService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_FlowService);
    this.Locations = this.injector.get(Locations_FlowService);
    this.Lots = this.injector.get(Lots_FlowService);
    this.LoadContainers = this.injector.get(LoadContainers_FlowService);
    this.Owners = this.injector.get(Owners_FlowService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_FlowService);
    this.Invoices = this.injector.get(Invoices_FlowService);
    this.Notifications = this.injector.get(Notifications_FlowService);
    this.Materials = this.injector.get(Materials_FlowService);
    this.DockAppointments = this.injector.get(DockAppointments_FlowService);
    this.SerialNumbers = this.injector.get(SerialNumbers_FlowService);
    this.SalesOrders = this.injector.get(SalesOrders_FlowService);
    this.Inventory = this.injector.get(Inventory_FlowService);
  }

    public Discussions: Discussions_FlowService;
    public Utilities: Utilities_FlowService;
    public Addresses: Addresses_FlowService;
    public AsnOrders: AsnOrders_FlowService;
    public Attachments: Attachments_FlowService;
    public Carriers: Carriers_FlowService;
    public Instructions: Instructions_FlowService;
    public ExcelOrderImport: ExcelOrderImport_FlowService;
    public Locations: Locations_FlowService;
    public Lots: Lots_FlowService;
    public LoadContainers: LoadContainers_FlowService;
    public Owners: Owners_FlowService;
    public PurchaseOrders: PurchaseOrders_FlowService;
    public Invoices: Invoices_FlowService;
    public Notifications: Notifications_FlowService;
    public Materials: Materials_FlowService;
    public DockAppointments: DockAppointments_FlowService;
    public SerialNumbers: SerialNumbers_FlowService;
    public SalesOrders: SalesOrders_FlowService;
    public Inventory: Inventory_FlowService;
  public FootPrintPortalManager: FootPrintPortalManager_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
